import { Text, VStack, Grid, GridItem } from '@chakra-ui/react';
import { LoyaltyCard } from '@olo-web/components/atoms/LoyaltyCard';
import { useOffersHelpers } from '@olo-web/components/organisms/Modals/ApplyOffersModal/hooks/useOffersHelpers';
import { useScreenSizeState } from '@olo-web/client-state';
import { getDiscountType } from '@olo-web/domain/customer/functions';
import { v4 as uuid } from 'uuid';
import { DiscountType, IOrderDiscount } from '@olo-web/domain/orders/types';
import { ILoyaltyItem } from '@olo-web/types/loyaltyReward.interface';

export const Rewards = () => {
  const { isSmDown } = useScreenSizeState();
  const { availableOffers, unavailableOffers } = useOffersHelpers();

  const availableRewards = availableOffers.filter(
    (offer: IOrderDiscount) => getDiscountType(offer) === DiscountType.REWARD
  );

  const unavailableRewards = unavailableOffers.filter(
    (offer: IOrderDiscount) => getDiscountType(offer) === DiscountType.REWARD
  );

  return (
    <VStack w="100%" spacing={3}>
      <Grid templateColumns={isSmDown ? '1fr' : 'repeat(2, 1fr)'} gap={isSmDown ? 3 : 4} w="100%">
        {availableRewards.map((reward) => (
          <GridItem key={reward.promotionId}>
            <LoyaltyCard isActive loyaltyItem={reward} />
          </GridItem>
        ))}
      </Grid>
      <Grid templateColumns={isSmDown ? '1fr' : 'repeat(2, 1fr)'} gap={isSmDown ? 3 : 4} w="100%">
        {unavailableRewards.map((reward) => (
          <GridItem key={uuid()}>
            <LoyaltyCard isActive={false} loyaltyItem={reward as ILoyaltyItem} />
          </GridItem>
        ))}
      </Grid>
      <Text w="100%" textStyle="p" lineHeight=".875rem">
        <strong>Note:</strong> Select items on our menu may be ineligible for rewards.
      </Text>
    </VStack>
  );
};
